import Notifications from '../components/Notifications';

export default Notifications;
